export default __webpack_public_path__ + "static/media/loader.cb0bb8df.gif";